export default "__VITE_ASSET__1164ca9f__"